import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatCardModule } from '@angular/material/card';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { IconNames } from '../../../../common/constants/icon-names';
import { ValidationService } from '../../../../common/services/validation.service';
import { ProfileType } from '../../../../store/constants';
import { SvgIconComponent } from '../../../svg-icon/svg-icon.component';
import { FieldErrorMessages } from '../../../field-error-messages/field-error-messages.component';

@Component({
  selector: 'ui-monitoring-profile-settings',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    MatCardModule,
    MatButtonToggleModule,
    MatFormFieldModule,
    MatInputModule,
    SvgIconComponent,
    FieldErrorMessages,
  ],
  templateUrl: './monitoring-profile-settings.component.html',
  styleUrls: ['./monitoring-profile-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MonitoringProfileSettingsComponent {
  @Input() set form(form: UntypedFormGroup) {
    if (form) {
      this.initProfileForm(form);
    }
  }
  @Input() isUserProfileCreator: boolean;
  @Input() isCloned: boolean;
  @Input() isProfileDetailsDisabled: boolean;

  profileForm: UntypedFormGroup;
  monitoringProfileType = ProfileType;
  iconNameList = IconNames;

  constructor(public validationService: ValidationService) {}

  private initProfileForm(form: UntypedFormGroup): void {
    this.profileForm = form;
  }
}
